<template>
  <nav class="navbar is-sticky has-shadow">
    <div class="container is-fluid plr-1-mobile">

      <!-- Brand -->
      <div class="navbar-brand">
        <div class="navbar-item">
          <img :src=" base + `/site/logos/iSIVINAVA-logo.png`" width="140">
          <span class="pl-1 has-text-grey has-text-weight-light is-size-5">BackOffice</span>
        </div>
      </div>

      <!-- Menu -->
      <div class="navbar-menu">
        <section class="navbar-start">
          <!-- <nav-route exact name="dashboard">Dashboard</nav-route> -->

          <!-- Bookings -->
          <nav-route exact name="bookings">Bookings</nav-route>

          <!-- Users -->
          <nav-dropdown title="Users">
            <nav-route exact name="user.customers">Customers</nav-route>
            <nav-route exact name="user.tenants">Tenants</nav-route>
            <nav-route exact name="user.admins">Admins</nav-route>
            <hr class="dropdown-divider">
            <nav-route exact name="user.signins">Sign-in History</nav-route>
          </nav-dropdown>

          <nav-route exact name="facilities">Facilities</nav-route>

          <!-- Site -->
          <nav-dropdown title="Site">
            <nav-route exact name="cms.home">Home Page</nav-route>
            <nav-route exact name="site.navigation">Navigation</nav-route>
            <nav-route exact name="cms.pages">Pages</nav-route>
            <nav-route exact name="cms.galleries">Galleries</nav-route>
          </nav-dropdown>

          <!-- Cinema -->
          <nav-dropdown title="Cinema">
            <nav-route exact name="cinema.screenings">Screenings</nav-route>
            <nav-route exact name="articles.index" :params="{ type: 'cinema' }">Articles</nav-route>
            <nav-route exact name="categories.index" :params="{ type: 'cinema' }">Categories</nav-route>
          </nav-dropdown>

          <!-- Cinema -->
          <nav-dropdown title="Library">
            <nav-route exact name="articles.index" :params="{ type: 'library' }">Articles</nav-route>
            <nav-route exact name="categories.index" :params="{ type: 'library' }">Categories</nav-route>
          </nav-dropdown>
        </section>

        <section class="navbar-end">
          <a target="_blank" :href="base" class="navbar-item">
            <icon icon="globe" :size=".75"/>
            <span>Site</span>
          </a>
          <nav-dropdown right :title="user.name" icon="user-solid-circle">
            <a class="navbar-item" @click="signOut">Sign out</a>
          </nav-dropdown>
        </section>

      </div>
    </div>
  </nav>
</template>


<script>
import { mapState } from 'vuex'

export default {

  computed: mapState('auth', ['user']),

  data: () => ({
    base: process.env.VUE_APP_BASE_URL
  }),

  methods: {
    signOut() {
      this.$store.dispatch('auth/logout').then(async callback => {
        await this.$router.push({
          name: 'login'
        })
        setTimeout(callback, 200)
      })
    }
  }

}
</script>
